import React from 'react';
import { useNavItems as themeUseNavItems } from 'gatsby-theme-carbon/src/util/NavItems';
import { DynamicIcon } from 'legion-ui';
import ListBadge from '../../components/ListBadge';

// add nav items
export function useNavItems() {
  const navItems = themeUseNavItems();
  return navItems.concat(
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Home" /> Home
        </div>
      ),
      pages: [{ path: '/', label: 'Home' }],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="MessageCircle" /> About us
        </div>
      ),
      pages: [{ path: '/about-us', label: 'About Us' }],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Airplay" /> Design
        </div>
      ),
      pages: [
        {
          path: '/design/getting-started/for-telkom-employee',
          title: 'Get Started',
          label: 'Get Started',
        },
        {
          path: '/design/project-setup',
          title: 'Project Setup',
          label: 'Project Setup',
        },
        {
          path: '/design/guideline/create-screen',
          title: 'Guideline',
          label: 'Guideline',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Code" /> Development
        </div>
      ),
      pages: [
        {
          path: '/development/installation/website',
          title: 'Installation',
          label: 'Installation',
        },
        {
          path: '/development/configuration/website',
          title: 'Configuration',
          label: 'Configuration',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Layers" /> Foundation
        </div>
      ),
      pages: [
        { path: '/foundation/overview', title: 'Overview', label: 'Overview' },
        {
          path: '/foundation/accessibility',
          title: 'Accessibility',
          label: 'Accessibility',
        },
        {
          path: '/foundation/color-system/website',
          title: 'Color System',
          label: 'Color System',
        },
        {
          path: '/foundation/typography/website',
          title: 'Typography',
          label: 'Typography',
        },
        {
          path: '/foundation/spacer/website',
          title: 'Spacer',
          label: 'Spacer',
        },
        {
          path: '/foundation/radius/website',
          title: 'Radius',
          label: 'Radius',
        },
        {
          path: '/foundation/elevation/website',
          title: 'Elevation',
          label: 'Elevation',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Box" /> Components
        </div>
      ),
      pages: [
        { path: '/components/overview', title: 'Overview', label: 'Overview' },
        {
          path: '/components/accordion/website',
          title: <ListBadge text="Accordion" type="update" />,
          label: 'Accordion',
        },
        {
          path: '/components/alert/website',
          title: <ListBadge text="Alert" />,
          label: 'Alert',
        },
        {
          path: '/components/anchor/guideline',
          title: <ListBadge text="Anchor" type="update" />,
          label: 'Anchor',
        },
        {
          path: '/components/avatar/guideline',
          title: <ListBadge text="Avatar" type="update" />,
          label: 'Avatar',
        },
        { path: '/components/badge/guideline', title: <ListBadge text="Badge" type="update" />, label: 'Badge' },
        {
          path: '/components/bottomsheet/guideline',
          title: <ListBadge text="Bottom Sheet" />,
          label: 'Bottom Sheet',
        },
        {
          path: '/components/box/website',
          title: <ListBadge text="Box" />,
          label: 'Box',
        },
        {
          path: '/components/button/guideline',
          title: <ListBadge text="Button" type="update" />,
          label: 'Button',
        },
        { path: '/components/card/guideline', title: <ListBadge text="Card" type="update" />, label: 'Card' },
        {
          path: '/components/carousel/guideline',
          title: <ListBadge text="Carousel" type="update" />,
          label: 'carousel',
        },
        {
          path: '/components/checkbox/guideline',
          title: <ListBadge text="Checkbox" type="update" />,
          label: 'Checkbox',
        },
        {
          path: '/components/chips/guideline',
          title: <ListBadge text="Chips" />,
          label: 'Chips',
        },
        {
          path: '/components/datepicker/guideline',
          title: <ListBadge text="Date Picker" type="new" />,
          label: 'Date Picker',
        },
        {
          path: '/components/divider/guideline',
          title: 'Divider',
          label: 'Divider',
        },
        {
          path: '/components/dropdown/guideline',
          title: <ListBadge text="Dropdown" />,
          label: 'Dropdown',
        },
        {
          path: '',
          title: <ListBadge text="Fab" type="upcoming" />,
          label: 'Fab',
        },
        {
          path: '/components/flex/website',
          title: <ListBadge text="Flex" />,
          label: 'Flex',
        },
        {
          path: '/components/grid/website',
          title: <ListBadge text="Grid" />,
          label: 'Grid',
        },
        {
          path: '/components/image/guideline',
          title: <ListBadge text="Image" />,
          label: 'Image',
        },
        {
          path: '/components/megamenu/website',
          title: <ListBadge text="Mega Menu" />,
          label: 'Mega Menu',
        },
        {
          path: '/components/modal/guideline',
          title: <ListBadge text="Modal" />,
          label: 'Modal',
        },
        {
          path: '/components/navigationbar/website',
          title: <ListBadge text="Navigation Bar" />,
          label: 'Navigation Bar',
        },
        {
          path: '/components/radiobutton/guideline',
          title: <ListBadge text="Radio Button" />,
        },
        {
          path: '/components/snackbar/guideline',
          title: 'Snackbar',
          label: 'SnackBar',
        },
        {
          path: '/components/selectfield/guideline',
          title: 'Select Field',
          label: 'Select Field',
        },
        {
          path: '/components/sidebar/website',
          title: <ListBadge text="Sidebar" />,
          label: 'Sidebar',
        },
        {
          path: '/components/spinner/guideline',
          title: 'Spinner',
          label: 'Spiner',
        },
        {
          path: '/components/stepper/website',
          title: <ListBadge text="Stepper" type="new" />,
          label: 'Stepper',
        },
        {
          path: '/components/switch/guideline',
          title: <ListBadge text="Switch" type="update" />,
          label: 'Switch',
        },
        {
          path: '/components/tabBar/website',
          title: <ListBadge text="Tab Bar" type="new" />,
          label: 'Tab Bar',
        },
        { path: '/components/table/guideline', title: 'Table', label: 'Table' },
        {
          path: '/components/textarea/guideline',
          title: <ListBadge text="Textarea" />,
          label: 'TextArea',
        },
        {
          path: '/components/textfield/guideline',
          title: <ListBadge text="Textfield" type="update" />,
          label: 'TextField',
        },
        {
          path: '/components/tooltip/guideline',
          title: 'Tooltip',
          label: 'Tooltip',
        },
        {
          path: '/components/viewstate/android',
          title: <ListBadge text="View State" />,
          label: 'View State',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Layout" /> Pattern
        </div>
      ),
      pages: [
        { path: '/pattern/overview', title: 'Overview', label: 'Overview' },
        {
          path: '/pattern/login-and-register/website',
          title: 'Login & Register',
          label: 'Login & Register',
        },
        {
          path: '/pattern/onboarding/mobile',
          title: 'On Boarding',
          label: 'On Boarding',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="Edit3" /> Content
        </div>
      ),
      pages: [
        { path: '/content/overview', title: 'Overview', label: 'Overview' },
        {
          path: '/content/writing-principles/website',
          title: 'Writing Principles',
          label: 'Writing Principles',
        },
        {
          path: '/content/mechanics/website',
          title: 'Mechanics',
          label: 'Mechanics',
        },
        {
          path: '/content/grammar/website',
          title: 'Grammar',
          label: 'Grammar',
        },
      ],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="FilePlus" /> Contribute & Request
        </div>
      ),
      pages: [{ path: '/contribute-and-request', label: 'Contribute & Request' }],
    },
    {
      title: (
        <div className="labelsidebar">
          <DynamicIcon size={15} name="AlertCircle" /> Release Notes
        </div>
      ),
      pages: [{ path: '/release-notes/website', label: 'Release Notes' }],
    }
  );
}
